import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';

import { initialState } from './GridSelection.redux';

const selectDomain = (state: RootState) => state?.selectedData || initialState;

export const selectGridSelection = createSelector([selectDomain], selectedData => selectedData);
